module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padded"
  }, [_vm._m(0), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "type": "border-card",
      "stretch": ""
    }
  }, _vm._l((_vm.list), function(l, i) {
    return _c('el-tab-pane', {
      key: l.type,
      attrs: {
        "label": l.type
      }
    }, [_c('el-row', [_c('el-col', {
      attrs: {
        "span": 24
      }
    }, [_c('el-table', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "data": l.data,
        "border": "",
        "size": "mini",
        "row-class-name": _vm.tableRowClassName
      }
    }, [_c('el-table-column', {
      attrs: {
        "prop": "seqNo",
        "width": 70,
        "align": "center",
        "label": "#"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "name",
        "width": 396,
        "label": "Type"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "stepName",
        "width": _vm.isDesktop ? 396 : 741,
        "label": "Step"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "status",
        "label": "Status"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "statusCount",
        "label": "# Status",
        "sortable": "",
        "align": "right",
        "formatter": _vm.formatInt
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "sites",
        "label": "Sites",
        "sortable": "",
        "align": "right",
        "formatter": _vm.formatInt
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "grading",
        "label": "Grading",
        "sortable": "",
        "align": "right",
        "formatter": _vm.formatInt
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "days",
        "label": "Days",
        "sortable": "",
        "align": "right",
        "formatter": _vm.formatInt
      }
    })], 1)], 1)], 1)], 1)
  }), 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('i', {
    staticClass: "fa fa-tachometer-alt"
  }), _vm._v(" Workflow Report")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d40f243"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/workflow/WorkflowReport.vue
// module id = 1434
// module chunks = 0